import React from 'react';

import {
	BUTTON_TYPES,
	EvButton,
	EvIcon,
	EvTableColumn,
	IssueInfoIcon,
	MultilineTextCellFormatter
} from '@evinced-private/ui-common';

import { SeverityTag } from 'src/apps/dashboard/components/severity-tag';
import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';

import { IAllIssue, IUniqueIssue } from '../types/IssuesTypes';

// TODO Placeholder for now
// eslint-disable-next-line @typescript-eslint/no-empty-function
const handleAction = (): void => {};

export const getAllIssuesColumns = (): EvTableColumn[] => [
	{
		dataField: 'issueType',
		text: 'Issue Type',
		sort: true,
		style: { width: '180px', maxWidth: '180px' },
		headerStyle: { width: '180px', maxWidth: '180px' },
		formatter: (text: string) => (
			<MultilineTextCellFormatter items={[text]} itemType="issueType" showTooltip />
		)
	},
	{
		dataField: 'severity',
		text: 'Severity',
		sort: true,
		style: { width: '120px', maxWidth: '150px', textAlign: 'center' },
		headerStyle: { width: '120px', maxWidth: '150px', textAlign: 'center' },
		formatter: (severity: string) => <SeverityTag severity={severity} />
	},
	{
		dataField: 'pageTitle',
		text: 'Page Title',
		sort: true,
		style: { width: '180px', maxWidth: '180px' },
		headerStyle: { width: '180px', maxWidth: '180px' },
		formatter: (text: string) => (
			<MultilineTextCellFormatter items={[text]} itemType="pageTitle" showTooltip />
		)
	},
	{
		dataField: 'pageUrl',
		text: 'Page URL',
		sort: true,
		style: { width: '220px', maxWidth: '220px' },
		headerStyle: { width: '220px', maxWidth: '220px' },
		formatter: (url: string) => (
			<a
				href={url}
				target="_blank"
				rel="noopener noreferrer"
				style={{
					display: 'block',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap'
				}}
			>
				{url}
			</a>
		)
	},
	{
		dataField: 'foundBy',
		text: 'Found By',
		sort: true,
		style: { width: '120px' }
	},
	{
		dataField: 'sessionOrTest',
		text: 'Session / Test',
		sort: true,
		style: { width: '150px' }
	},
	{
		dataField: 'user',
		text: 'User',
		sort: true,
		style: { width: '120px' }
	},
	{
		dataField: 'actions',
		text: '',
		style: { width: '50px' },
		formatter: (_cell: unknown, row: IAllIssue) => (
			<EvButton
				title="Issue Details"
				type={BUTTON_TYPES.ICON}
				onClick={handleAction}
				accessibilityProps={{
					'aria-label': `Show details for ${row.issueType}`
				}}
			>
				<EvIcon icon={IssueInfoIcon} />
			</EvButton>
		)
	}
];

export const getUniqueIssuesColumns = (): EvTableColumn[] => [
	{
		dataField: 'issueType',
		text: 'Issue Type',
		sort: true,
		style: { width: '180px', maxWidth: '180px' },
		headerStyle: { width: '180px', maxWidth: '180px' },
		formatter: (text: string) => (
			<MultilineTextCellFormatter items={[text]} itemType="issueType" showTooltip />
		)
	},
	{
		dataField: 'severity',
		text: 'Severity',
		sort: true,
		style: { width: '120px', maxWidth: '120px', textAlign: 'center' },
		headerStyle: { width: '120px', maxWidth: '120px', textAlign: 'center' },
		formatter: (severity: string) => <SeverityTag severity={severity} />
	},
	{
		dataField: 'pageTitle',
		text: 'Page Title',
		sort: true,
		style: { width: '180px', maxWidth: '180px' },
		headerStyle: { width: '180px', maxWidth: '180px' },
		formatter: (text: string) => (
			<MultilineTextCellFormatter items={[text]} itemType="pageTitle" showTooltip />
		)
	},
	{
		dataField: 'pageUrl',
		text: 'Page URL',
		sort: true,
		style: { width: '220px', maxWidth: '220px' },
		headerStyle: { width: '220px', maxWidth: '220px' },
		formatter: (url: string) => (
			<a
				href={url}
				target="_blank"
				rel="noopener noreferrer"
				style={{
					display: 'block',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap'
				}}
			>
				{url}
			</a>
		)
	},
	{
		dataField: 'firstSeen',
		text: 'First seen',
		sort: true,
		style: { width: '180px' },
		formatter: (date: string) => formatShortMonthDatetime(date)
	},
	{
		dataField: 'lastSeen',
		text: 'Last seen',
		sort: true,
		style: { width: '180px' },
		formatter: (date: string) => formatShortMonthDatetime(date)
	},
	{
		dataField: 'actions',
		text: '',
		style: { width: '50px' },
		formatter: (_cell: unknown, row: IUniqueIssue) => (
			<EvButton
				title="Issue Details"
				type={BUTTON_TYPES.ICON}
				onClick={handleAction}
				accessibilityProps={{
					'aria-label': `Show details for ${row.issueType}`
				}}
			>
				<EvIcon icon={IssueInfoIcon} />
			</EvButton>
		)
	}
];
